import React, {useContext} from "react";
import category from "../css/category.css";
import {ShopContext} from "./Providers/ShopContext";
import dropdown_icon from "./Assets/dropdown_icon.png";
import Items from "./Items";

const ShopCategory = (props) => {
  const {all_product} = useContext(ShopContext);
  return (
    <div style={category} className="shop-category">
      <img src={props.banner} alt="" />
      <div className="category-index">
        <p>
          <span>Showing 1-12</span> of 36 products
        </p>
        <div className="category-sort">
          Sort by <img src={dropdown_icon} alt="" />
        </div>
      </div>
      <div className="category-product">
        {all_product.map((item, i) => {
          if (props.category === item.category) {
            return (
              <Items
                key={i}
                id={item.id}
                name={item.name}
                image={item.image}
                new_price={item.new_price}
                old_price={item.old_price}
              />
            );
          }
        })}
      </div>

      <button className="more">Load more</button>
    </div>
  );
};

export default ShopCategory;
